import {useEffect, useState} from "react";
import styles from './Loading.module.scss'
import {classNames} from "@shared/utils";

export const Loading = ({}) => {

    const arrayElements = [[1,2],[4,3],[5,6]]

    const [target, setTarget] = useState(1)

    useEffect(() => {
        const timer = setInterval(() => setTarget(target => target + 1), 100)
        if (target > 9 ) {
            setTarget(1)
        }
        return () => {
            clearInterval(timer)
        }
    }, [target]);


    return (
        <div className={styles.root}>
            {arrayElements.map((array, index) =>
                <div key={index} className={styles.row}>
                    {array.map((element, index) =>
                        <span key={index} className={classNames(styles.element, target === element ? styles.element_active : '')}/>
                    )}
                </div>

            )}
        </div>
    )
}